import { Button } from '~/components/general/Button'
import { ImageMiniCard } from '~/components/main-page/SimulateInterview/ImageMiniCard'
import { ImageFullCard } from '~/components/main-page/SimulateInterview/ImageFullCard'
import { trackEvent } from '~/utils/tracking'
import { FlexContainer } from '~/components/Grid'
import { TypeHomePageBlock } from '~/types/contentful'

type SimulateInterviewProps = {
  section: TypeHomePageBlock<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const SimulateInterview = ({ section }: SimulateInterviewProps) => {
  const data = section.fields

  const handleCTABtnClick = () => {
    trackEvent('homepage_click_cta', {
      block: data.blockId,
      target: data.buttonLink as string,
      homepage_CTA: data.buttonName as string,
    })
  }

  return (
    <>
      <section
        className="mt-25 -mx-8 mb-40 max-xl:my-25 max-xl:-mx-8 max-xl:px-11 max-lg:my-15 max-lg:-mx-7 max-md:py-0 max-md:px-4 max-md:m-[60px_-18px_60px] "
        data-block-id={data.blockId}
      >
        <FlexContainer
          flexWrap={'nowrap'}
          justify={'start'}
          className="group gap-12 bg-neutral-5 min-h-[572px] rounded-[40px] overflow-hidden max-xl:min-h-[510px] max-md:pb-8 max-lg:flex-col max-lg:items-center max-lg:min-h-[none] max-md:gap-8 max-md:p-5"
        >
          <div className="[&_img]:max-w-[308px] max-lg:[&_img]:max-w-none flex basis-1/2 gap-3 pt-22 max-md:flex-col max-md:p-0 max-md:gap-2 max-lg:w-full max-xl:pt-18">
            <div className="h-full overflow-hidden max-lg:w-[60%] max-md:w-full min-w-[250px] rounded-[0_8px_0_0] [&_img]:h-full">
              <img
                className="block max-md:hidden w-full h-auto object-cover"
                src="/images/girl_video.png"
                alt=""
                loading="lazy"
              />
              <img
                className="block md:hidden w-full h-auto object-cover"
                src="/images/video_window_mini.png"
                alt=""
                loading="lazy"
              />
            </div>
            <div className="flex md:flex-col gap-3 max-md:gap-2 max-md:min-w-[auto] min-w-[225px] [&:nth-child(3)]:block max-md:first:hidden max-md:[&:nth-child(2)]:flex-shrink-[2]">
              <div
                className="rounded-xl p-3 bg-white text-center w-full first:py-6 first:px-3 [&:nth-child(2)]:rounded-[12px_12px_0_0] block max-md:hidden"
                style={{
                  boxShadow:
                    '0px 2px 4px 0px rgba(15, 56, 113, 0.08), 0px 1px 2px 0px rgba(15, 56, 113, 0.12)',
                }}
              >
                <ImageMiniCard />
              </div>
              <div
                className="rounded-xl p-3 bg-white text-center w-full first:py-6 first:px-3 [&:nth-child(2)]:rounded-[12px_12px_0_0] block max-md:hidden"
                style={{
                  boxShadow:
                    '0px 2px 4px 0px rgba(15, 56, 113, 0.08), 0px 1px 2px 0px rgba(15, 56, 113, 0.12)',
                }}
              >
                <ImageFullCard />
              </div>
              <img
                src="/images/SimulateInterview_mobile.png"
                loading="lazy"
                alt=""
                className="hidden max-md:w-full max-md:block object-cover"
              />
            </div>
          </div>
          <FlexContainer
            justify={'start'}
            flexWrap={'nowrap'}
            className="max-w-[378px] p-[86px_0px_110px_0] max-lg:p-[20px_34px_40px_0ºx] max-lg:max-w-[70%] max-lg:basis-1/2 max-md:p-0 max-md:w-full max-md:max-w-full max-md:basis-full relative flex-col gap-8 items-start max-md:gap-4 max-md:items-stretch lg:ml-0"
          >
            <h2 className="text-l max-md:text-left">{data.title}</h2>
            <p className="text-s max-md:hidden max-xl:max-w-[290px]">{data.description}</p>
            <Button
              text={data.buttonName}
              type={'link'}
              className={'w-fit'}
              href={data.buttonLink}
              onClick={handleCTABtnClick}
            />
          </FlexContainer>
        </FlexContainer>
      </section>
    </>
  )
}
